import courseDetails from './courseDetails';
import courseDetailsRtId from './courseDetailsRtId';
import createCourse from './createCourse';
import deleteCourse from './deleteCourse';
import archiveCourse from './archiveCourse';
import fetchCourseList from './fetchCourseList';
import FetchInstructorCourses from './FetchInstructorCourses';
import FetchParticipantCourses from './FetchParticipantCourses';
import fetchStudentCourseSummary from './fetchStudentCourseSummary';
import getStudentActivities from './getStudentActivities';
import getMyStudentActivities from './getMyStudentActivities';
import getStudentSkills from './getStudentSkills';
import getMyStudentSkills from './getMyStudentSkills';
import joinCourse from './joinCourse';
import removeStudents from './removeStudents';
import updateCourse from './updateCourse';
import updateRTsCriteria from './updateRTsCriteria';
import fetchTrendingOnline from './fetchTrendingOnline';
import fetchTrendingLive from './fetchTrendingLive';
import joinFirstLrtInCourse from './joinFirstLrtInCourse';
import joinFirstOrtInCourse from './joinFirstOrtInCourse';
import importFeedbackLive from './importFeedbackLive';
import importFeedbackOnline from './importFeedbackOnline';
import saveFeedback from './saveFeedback';
import updateFeedback from './updateFeedback';
import deleteFeedback from './deleteFeedback';
import exportStudentReportData from './exportStudentReportData';
import syncCourses from './syncCourses';
import createAdminSubscription from './createAdminSubscription';
import toggleCourseChat from './toggleCourseChat';
import sendChatMessage from './sendChatMessage';
import deleteChatMessage from './deleteChatMessage';
import deleteAllChatMessages from './deleteAllChatMessages';
import readCourseMessages from './readCourseMessages';
import loadMoreMessages from './loadMoreMessages';
import loadChatMessage from './loadChatMessage';
import syncGoogleClassroomCourse from './syncGoogleClassroomCourse';
import unsyncGoogleClassroomCourse from './unsyncGoogleClassroomCourse';
import importStudentsFromEdlink from './importStudentsFromEdlink';
import unsyncStudentFromCourse from './unsyncStudentFromCourse';
import removeSampleCourse from './removeSampleCourse';
// TO DEPRECATE:
import loadCourses from './loadCourses';
import getTeachers from './getTeachers';
import showCoursesWithFeedback from './showCoursesWithFeedback';
import addStudentToCourse from './addStudentToCourse';
import addStudentToCourseCSV from './addStudentToCourseCSV';
export default {
  courseDetails,
  courseDetailsRtId,
  createCourse,
  deleteCourse,
  archiveCourse,
  fetchCourseList,
  fetchStudentCourseSummary,
  getStudentActivities,
  getMyStudentActivities,
  getStudentSkills,
  getMyStudentSkills,
  joinCourse,
  loadCourses,
  removeStudents,
  updateCourse,
  updateRTsCriteria,
  fetchTrendingOnline,
  fetchTrendingLive,
  joinFirstLrtInCourse,
  joinFirstOrtInCourse,
  saveFeedback,
  updateFeedback,
  importFeedbackLive,
  importFeedbackOnline,
  deleteFeedback,
  getTeachers,
  exportStudentReportData,
  syncCourses,
  createAdminSubscription,
  toggleCourseChat,
  sendChatMessage,
  deleteChatMessage,
  deleteAllChatMessages,
  readCourseMessages,
  loadMoreMessages,
  loadChatMessage,
  syncGoogleClassroomCourse,
  unsyncGoogleClassroomCourse,
  importStudentsFromEdlink,
  showCoursesWithFeedback,
  unsyncStudentFromCourse,
  removeSampleCourse,
  addStudentToCourse,
  addStudentToCourseCSV,
  FetchInstructorCourses,
  FetchParticipantCourses
};



// WEBPACK FOOTER //
// ./src/app/services/courses/index.js